var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16.011,
  height: 16.012,
  viewBox: "0 0 16.011 16.012"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon-search",
  transform: "translate(6185.766 1076.506)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M7.116,14.233a7.116,7.116,0,1,1,7.116-7.116,7.125,7.125,0,0,1-7.116,7.116m0-12.454a5.337,5.337,0,1,0,5.337,5.337A5.343,5.343,0,0,0,7.116,1.779",
  transform: "translate(-6185.766 -1076.506)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M16.448,17.337a.887.887,0,0,1-.629-.261l-3.558-3.558a.889.889,0,1,1,1.258-1.258l3.558,3.558a.89.89,0,0,1-.629,1.518",
  transform: "translate(-6187.092 -1077.832)"
}))));
export default SvgIconSearch;